module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "entity": _vm.formModel,
      "fields": _vm.fields,
      "cancel": false
    },
    on: {
      "change": _vm.onChange,
      "submit": _vm.onSubmit
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0662254!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setup-guide/ServerDomainSetup.vue
// module id = 1188
// module chunks = 2